/*=========================================================================================
  File Name: moduleCalendarGetters.js
  Description: Calendar Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
export default {
	getStandardOutput: (state) => () => state.standardOutput,
	getRountingsDoneFromMap: (state) => (itemId) => state.rountingsDoneMap.get(itemId),
	formatDataResourceToRoute: (state) => (resources) => {
		const validatePropertie = (property) => (property === null || property === undefined ? false : true);
		const validateDepots = (depot_id, num) => (depot_id[num] ? true : false);
		const selectedResourcesFormat = resources.map((el) => {
			return {
				resource_id: el.id,
				first_capacity: validatePropertie(el.first_capacity),
				second_capacity: validatePropertie(el.second_capacity),
				third_capacity: validatePropertie(el.third_capacity),
				hour_window: validatePropertie(el.init_hour_window) && validatePropertie(el.end_hour_window),
				init_depot: validateDepots(el.depot_id, 0),
				end_depot: validateDepots(el.depot_id, 1),
				breaks: validatePropertie(el.break_id),
				skills: validatePropertie(el.skills_id),
				max_travel_distance: true,
				max_travel_duration: true,
			};
		});
		return selectedResourcesFormat;
	},
};
